<template>
  <div class="form-group form-group--checkbox" v-bind:class="getClass()">
    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}
          <span class="required" v-if="isRequired()">*</span>
        </label>
        <span class="help-block" v-if="component.description">{{ component.description }}</span>
        <div v-bind:class="component.type" v-if="component.inline">
          <label v-bind:class="`${component.type}-inline`"
                 v-for="(v, index) in values"
                 v-bind:key="index">
            <input v-bind:type="component.type"
                   v-bind:name="component.key"
                   v-bind:value="v"
                   :id="component.key"
                   v-model="component.data.currentValue"
                   v-bind:disabled="disabledHandler()"
                   v-bind:checked="checkItem(v)"
                   v-validate="setRules()"
                   v-on:focus="focusHandler()"
                   v-on:blur="blurHandler()"
                   v-bind:data-vv-name="component.key">
            {{ v.label }}
            <span v-if="v.dataHelp" v-html="formata(v.dataHelp)" class="data-help"></span>
          </label>
        </div>
        <div v-for="(v, index) in values" v-bind:key="index" v-bind:class="component.type" v-else>
          <label>
            <input v-bind:type="component.type"
                   v-bind:value="v"
                   v-bind:name="component.key"
                   :id="component.key"
                   v-bind:disabled="disabledHandler()"
                   v-model="component.data.currentValue"
                   v-bind:checked="checkItem(v)"
                   v-validate="setRules()"
                   v-on:focus="focusHandler()"
                   v-on:blur="blurHandler()"
                   v-bind:data-vv-name="component.key">
            {{ v.label }}
          </label>
          <span v-if="v.dataHelp" v-html="formata(v.dataHelp)" class="data-help"></span>
        </div>
        <span class="help-block help-block--bottom" v-if="errors.has(component.key)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">
            <g id="form_icon_error_alert" transform="translate(-252 -635)">
              <rect id="rectangle" class="cls-1" width="14" height="14" transform="translate(252 635)"/>
              <path id="ic_error_outline_24px" class="cls-2" d="M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z" transform="translate(251 634)"/>
            </g>
          </svg>
          {{ (errors.first(component.key)) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
// https://br.vuejs.org/v2/guide/mixins.html
import component from '@/mixins/component'

export default {
  mixins: [component],
  props: ['component'],
  inject: ['$validator'],
  name: 'form-component-checkbox',
  data () {
    return {
      isFocus: false,
      isValue: false,
      isErrors: false,
      values: []
    }
  },
  methods: {
    async getValues () {
      this.values = []

      if (this.component.data.sourceType === 'json') {
        for (let i = 0; i < this.component.data.json.length; i++) {
          this.values.push({
            label: this.component.data.json[i][this.component.data.propertyLabel],
            value: this.component.data.json[i][this.component.data.propertyValue]
          })
        }
      } else if (this.component.data.sourceType === 'values') {
        this.values = this.component.data.sourceValues
      } else if (this.component.data.sourceType === 'injectedJson') {
        if (this.config.json) {
          this.component.data.injectedJson = this.component.data.injectedJson.replace('json', 'this.config.json')
          try {
            /* eslint-disable no-eval */
            let keyCustom = eval(this.component.data.injectedJson)

            if (keyCustom) {
              for (let i = 0; i < keyCustom.length; i++) {
                this.values.push({
                  label: keyCustom[i][this.component.data.propertyLabel],
                  value: keyCustom[i][this.component.data.propertyValue]
                })
              }
            }
          } catch (e) {
            // Ignore error
          }
        }
      }
    },
    changeVal (val) {
      this.component.data.currentValue = val
    },
    getOptionValue (item) {
      return item && typeof item === 'object' ? item.value : item
    },
    checkItem (item) {
      if (!Array.isArray(this.component.data.currentValue)) {
        return false
      }

      const result = this.component.data.currentValue.find(value => {
        return String(this.getOptionValue(value)) === String(this.getOptionValue(item))
      })

      return !!result
    },
    normalizeCurrentValue () {
      if (!Array.isArray(this.component.data.currentValue) || !this.values.length) {
        return
      }

      const normalizedCurrentValue = this.component.data.currentValue.map(item => {
        return this.values.find(value => {
          return String(value.value) === String(this.getOptionValue(item))
        }) || item
      })

      const hasChange = normalizedCurrentValue.some((item, index) => item !== this.component.data.currentValue[index])

      if (hasChange) {
        this.component.data.currentValue = normalizedCurrentValue
      }
    },
    formata (text) {
      const texto = text.replace(/(\\r)*\\n/g, '<br>')
      return texto
    }
  },
  async created () {
    await this.getValues()
    this.setValue()
    this.normalizeCurrentValue()
  },
  watch: {
    values: function () {
      this.normalizeCurrentValue()
    },
    'component.data.currentValue': function (after, before) {
      if (after && Array.isArray(after)) {
        this.normalizeCurrentValue()
      }
    }
  }
}
</script>
<style>
 .data-help {
   display: block;
   white-space: pre-wrap;
   margin-top: 5px;
   font-size: 12px;
   margin-left: 20px;
 }
</style>
